<template>
  <div id="app">
    <layout></layout>
  </div>
</template>

<script>
import Layout from "./Layout/Layout";

export default {
  name: "App",
  components: {
    Layout
  }
};
</script>

<style scoped>
</style>
